import React from 'react'
import {Switch, Route} from 'react-router-dom'
import Login from './views/login.js'
import CSConnectApp from './views/cs-connect-app'
import {isAuthenticated} from './util/helpers'
import {getSessionKey, USERNAME_KEY} from './util/storage'

export default () => (
  <Switch>
    <Route exact path='/' render={renderBasedonAuthenticationCheck}/>
    <Route path='/search' component={CSConnectApp}/>
    {
      getSessionKey(USERNAME_KEY) && getSessionKey(USERNAME_KEY).includes('@creditsafe')
        ? <Route path='/analysis' component={CSConnectApp}/> : null
    }
    <Route path='/monitoringTranslations' component={CSConnectApp}/>
    <Route path='*' render={(props) => {
      props.history.push('/')
      return null
    }}/>
  </Switch>
)

const renderBasedonAuthenticationCheck = (props) => {
  if (isAuthenticated()) {
    props.history.push('/search')
    return null
  }
  return <Login {...props}/>
}



// WEBPACK FOOTER //
// ./src/app.js